import { getElementsByClassName, skeleton } from './utils';

export const setupMathjax = () => {
  const math = getElementsByClassName<HTMLDivElement>('math');

  if (math?.length) {
    const skeletonElements = math.map((mathElement) => {
      const skeletonElement = skeleton('100%', '3\0px', '0 0 12px');

      mathElement.style.display = 'none';
      mathElement.parentNode?.insertBefore(skeletonElement, mathElement);

      return skeletonElement;
    });

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js';
    script.async = true;
    script.defer = true;
    script.onload = async () => {
      skeletonElements.forEach((skeletonElement) => {
        skeletonElement.remove();
      });
      math.forEach((mathElement) => (mathElement.style.display = 'block'));
    };
    document.head.appendChild(script);
  }
};
